import React, {Component} from "react";
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import moment from "moment-timezone";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import ScheduleResult from "../ScheduleResult/ScheduleResult";

import {getDateFromDateString, getHours, getAMorPM} from '../../shared/dateFormatter';
import queryString from "query-string";

import {requestScheduleData, resetNoResultsScheduleData} from "../../actions/schedulesDataActions";
import {REQUEST_INTERLINE_OPERATORS} from "../../actions/interlineOperatorsActions";
import Select from "../Select/Select";
import {REQUEST_NON_REV_AND_REV_FACILITIES_DATA} from "../../actions/nonRevAndRevFacilitiesActions";

class scheduleResults extends Component {

    state = {
        "routes": []
    }

    componentDidMount() {
        if (!this.props.nonRevAndRevFacilities) {
            this.props.getNonRevAndRevFacilities();
        }
        if (!Object.keys(this.props.interlineOperatorsData).length) {
            this.props.getInterlineOperators();
        }
        this.setState({
            "routes": this.props.routes,
            "routeSortDuration": "Duration",
            "routeSortArrivalTime": "Arrival Time",
            "routeSortDepartureTime": "Departure Time",
        });
    }

    serviceChange(event) {
        let params = queryString.parse(this.props.location.search);

        params.serviceLevel = event.target.value;

        params.nonRevAndRevFacilities = this.props.nonRevAndRevFacilities;

        this.props.resetNoResultsScheduleData();
        this.props.getScheduleData(params);

    }

    previousDate() {
        let params = queryString.parse(this.props.location.search);

        params.date = moment(queryString.parse(this.props.location.search).date).subtract(1, "days").format("YYYY-MM-DD");

        params.nonRevAndRevFacilities = this.props.nonRevAndRevFacilities;

        this.props.resetNoResultsScheduleData();
        this.props.getScheduleData(params);

    };

    nextDate() {
        let params = queryString.parse(this.props.location.search);

        params.date = moment(queryString.parse(this.props.location.search).date).add(1, "days").format("YYYY-MM-DD");

        params.nonRevAndRevFacilities = this.props.nonRevAndRevFacilities;

        this.props.resetNoResultsScheduleData();
        this.props.getScheduleData(params);

    };

    static isOutsideDateRange(momentDate) {
        let maxDate = moment().add(10, 'day');
        let minDate = moment();

        return !momentDate.isBetween(minDate, maxDate);
    };

    sortRoutes = (event) => {
        let routes = this.state.routes;

        if (event.target.value === this.state.routeSortDuration) {
            routes.sort(function (a, b) {
                if (a.routeTransitTime < b.routeTransitTime) {
                    return -1;
                }
                if (a.routeTransitTime > b.routeTransitTime) {
                    return 1;
                }
                return 0;
            });
        } else if (event.target.value === this.state.routeSortDepartureTime) {
            routes.sort(function (a, b) {
                let scheduledDepartureDateA = new Date(a.segments.segment[0].scheduledDepartureDate);
                let scheduledDepartureDateB = new Date(b.segments.segment[0].scheduledDepartureDate);
                if (scheduledDepartureDateA < scheduledDepartureDateB) {
                    return -1;
                }
                if (scheduledDepartureDateA > scheduledDepartureDateB) {
                    return 1;
                }
                return 0;
            });
        } else {
            routes.sort(function (a, b) {
                let scheduledArrivalDateA = new Date(a.segments.segment[a.segments.segment.length - 1].scheduledArrivalDate);
                let scheduledArrivalDateB = new Date(b.segments.segment[b.segments.segment.length - 1].scheduledArrivalDate);
                if (scheduledArrivalDateA < scheduledArrivalDateB) {
                    return -1;
                }
                if (scheduledArrivalDateA > scheduledArrivalDateB) {
                    return 1;
                }
                return 0;
            });
        }

        this.setState({
            "routes": routes
        });
    };

    render() {

        const operators = this.props.interlineOperatorsData.operators;

        return (
                <div className="schedule-results mtl">
                    <AppBar position="static" className="schedule-results__app-bar">
                        <Toolbar className="schedule-results__toolbar">
                            <Typography variant="title" color="inherit" className="schedule-results__title">
                                {
                                        moment(queryString.parse(this.props.location.search).date).format("dddd") + ", "
                                }
                                {
                                    moment(queryString.parse(this.props.location.search).date).format("MMM. DD")
                                }
                            </Typography>
                            <div className="schedule-results__tabs">
                                <Button
                                        disabled={scheduleResults.isOutsideDateRange(moment(queryString.parse(this.props.location.search).date))}
                                        onClick={() => {
                                            this.previousDate()
                                        }} className="schedule-results__tab schedule-results__tab--past" disableRipple={true}>
                                    <div className="schedule-results-tab-day">
                                        {
                                            moment(queryString.parse(this.props.location.search).date).subtract(1, "days").format("ddd")
                                        }
                                    </div>
                                    <div
                                            className="schedule-results-tab-date"
                                            style={{textTransform: "capitalize"}}>{moment(queryString.parse(this.props.location.search).date).subtract(1, "days").format("MMM. DD")}</div>
                                </Button>
                                <Button className="schedule-results__tab schedule-results__tab--active" disableRipple={true}>
                                    <div className="schedule-results-tab-day">
                                        {
                                            moment(queryString.parse(this.props.location.search).date).format("ddd")
                                        }
                                    </div>
                                    <div className="schedule-results-tab-date"
                                         style={{textTransform: "capitalize"}}>{moment(queryString.parse(this.props.location.search).date).format("MMM. DD")}</div>
                                </Button>
                                <Button
                                        disabled={scheduleResults.isOutsideDateRange(moment(queryString.parse(this.props.location.search).date).add(1, "days"))}
                                        onClick={() => {
                                            this.nextDate()
                                        }} className="schedule-results__tab schedule-results__tab--future"
                                        disableRipple={true}>
                                    <div className="schedule-results-tab-day">
                                        {
                                            moment(queryString.parse(this.props.location.search).date).add(1, "days").format("ddd")
                                        }
                                    </div>
                                    <div
                                            className="schedule-results-tab-date"
                                            style={{textTransform: "capitalize"}}>{moment(queryString.parse(this.props.location.search).date).add(1, "days").format("MMM. DD")}</div>
                                </Button>
                            </div>
                        </Toolbar>
                    </AppBar>
                    <div className="schedule-results__service-level-container">

                        <div className="schedule-results__service-level-image-container">
                            <img className="schedule-results__service-level-image"
                                 src="./assets/ship/CargoFlightSchedules/change-planes.svg" alt=""/>
                            <p className="schedule-results__service-level-text">= Change planes</p>
                        </div>

                        {this.props.segmentTypes.map(segmentType => {
                            if (segmentType === "TRUCK") return (
                                    <div className="schedule-results__service-level-image-container">
                                        <img className="schedule-results__service-level-image"
                                             src="./assets/ship/CargoFlightSchedules/truck.svg" alt=""/>
                                        <p className="schedule-results__service-level-text">= Road Feeder Service</p>
                                    </div>
                            );
                            return null;
                        })}

                    </div>
                    <div style={{width: "200px", marginTop: "20px"}}>
                        <Select hasPleaseSelectOption={true}
                                name="sort"
                                title={"Sort By"}
                                selected={"duration"}
                                options={[
                                    {
                                        "key": "departureTime",
                                        "name": this.state.routeSortDepartureTime
                                    },
                                    {
                                        "key": "arrivalTime",
                                        "name": this.state.routeSortArrivalTime
                                    },
                                    {
                                        "key": "duration",
                                        "name": this.state.routeSortDuration
                                    }]}
                                onChange={this.sortRoutes}
                                desktopWidth={'100%'}
                                tabletWidth={'100%'}
                                mobileWidth={'100%'}
                        />
                    </div>
                    <div className="schedule-results__list">

                        {
                            this.state.routes.map((item) => {

                                const scheduledDepartureDate = item.segments.segment[0].scheduledDepartureDate;
                                const scheduledArrivalDate = item.segments.segment[item.segments.segment.length - 1].scheduledArrivalDate;

                                const estimatedDepartureDate = item.segments.segment[0].estimatedDepartureDate;
                                const estimatedArrivalDate = item.segments.segment[item.segments.segment.length - 1].estimatedArrivalDate;

                                const isDepartureDelayed = scheduledDepartureDate < estimatedDepartureDate;
                                const isArrivalDelayed = scheduledArrivalDate < estimatedArrivalDate;

                                const originTimeZone = item.segments.segment[0].originTimeZone && item.segments.segment[0].originTimeZone.includes('/')
                                        ? (() => {
                                            try {
                                                return moment().tz(item.segments.segment[0].originTimeZone).zoneAbbr();
                                            } catch (e) {
                                                return item.segments.segment[0].originTimeZone;
                                            }
                                        })()
                                        : item.segments.segment[0].originTimeZone;

                                const destinationTimeZone = item.segments.segment[item.segments.segment.length - 1].destinationTimeZone && item.segments.segment[item.segments.segment.length - 1].destinationTimeZone.includes('/')
                                        ? (() => {
                                            try {
                                                return moment().tz(item.segments.segment[item.segments.segment.length - 1].destinationTimeZone).zoneAbbr();
                                            } catch (e) {
                                                return item.segments.segment[item.segments.segment.length - 1].destinationTimeZone;
                                            }
                                        })()
                                        : item.segments.segment[item.segments.segment.length - 1].destinationTimeZone;


                                let departureStatus = "On Time";
                                let arrivalStatus = "On Time";

                                if (isDepartureDelayed) {
                                    departureStatus = "Delayed";
                                }

                                if (isArrivalDelayed) {
                                    arrivalStatus = "Delayed";
                                }

                                const flights = item.segments.segment.map((segment) => {
                                    return segment.flightNumber
                                });

                                let operatedBy = "";

                                if (operators) {
                                    const operator = operators.find(operator => {
                                        return operator.code === item.segments.segment[0].carrier;
                                    });
                                    operatedBy = operator ? "Operated by " + operator.name : "";
                                }

                                return (
                                        <ScheduleResult
                                                key={item.index}
                                                flightNumber={flights.join(" / ")}
                                                nonRevAndRevFacilities={this.props.nonRevAndRevFacilities}
                                                operatedBy={operatedBy}
                                                departure={{
                                                    scheduledTime: getHours(scheduledDepartureDate),
                                                    scheduledDate: getDateFromDateString(scheduledDepartureDate),
                                                    actualTime: '',
                                                    meridiem: getAMorPM(scheduledDepartureDate),
                                                    timezone: originTimeZone,
                                                    status: departureStatus
                                                }}
                                                arrival={{
                                                    scheduledTime: getHours(scheduledArrivalDate),
                                                    scheduledDate: getDateFromDateString(scheduledArrivalDate),
                                                    actualTime: "",
                                                    meridiem: getAMorPM(scheduledArrivalDate),
                                                    timezone: destinationTimeZone,
                                                    status: arrivalStatus,
                                                }}
                                                planeChange={item.noOfConnections}
                                                stops={item.segments.segment}
                                                location={this.props.location}

                                        />);
                            })}
                    </div>
                </div>
        )
    }
}

scheduleResults.propTypes = {
    routes: PropTypes.array.isRequired
};

const mapStateToProps = state => ({
    nonRevAndRevFacilities: state.nonRevAndRevFacilitiesData.nonRevAndRevFacilities,
    interlineOperatorsData: state.interlineOperatorsData
});

const mapDispatchToProps = dispatch => ({
    getNonRevAndRevFacilities: () => dispatch({type: REQUEST_NON_REV_AND_REV_FACILITIES_DATA}),
    getScheduleData: data => {
        dispatch(requestScheduleData(data))
    },
    resetNoResultsScheduleData: () => dispatch(resetNoResultsScheduleData()),
    getInterlineOperators: () => dispatch({type: REQUEST_INTERLINE_OPERATORS})
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(scheduleResults));




// WEBPACK FOOTER //
// ./src/components/ScheduleResults/ScheduleResults.js